export default function($) {
  var speed = 90; // ms

  $('.menu-item-has-children').click(function (event) {
    event.stopPropagation();
    $(this).siblings('.menu-item-has-children--active').each(function(i, sibling) {
      $(sibling).removeClass('menu-item-has-children--active').children('.sub-menu').slideUp(speed);
    });
    $(this).children('.sub-menu').slideToggle(speed);
    $(this).toggleClass('menu-item-has-children--active');
  });

  $(document).click(function(event) {
    if (!$(event.target).closest('.js-nav').length) {
      if ($('.sub-menu').is(":visible")) {
        $('.sub-menu').slideUp(speed);
        $('.menu-item-has-children--active').removeClass('menu-item-has-children--active');
      }
    }
  });

  $(window).scroll(function() {
    if ($(this).scrollTop() >= 100) {
      $('.js-backtotop').fadeIn();
    } else {
      $('.js-backtotop').fadeOut();
    }
  });

  $("#menu-toggle").click(function() {
    $(".menu-principal").toggleClass("hidden");
    $("#icon-open").toggle("hidden");
    $("#icon-close").toggle("hidden");
    $(".menu-menu-principal-container").toggleClass("fixed top-0 m-30 z-80 w-full h-full bg-white pt-8");
  });

  $(".cookie-panel").click (function() {
    javascript:Didomi.preferences.show()
  });
}
